export default __webpack_public_path__ + "media/images/icons_fc/up-a5a7fe2e5ec0f65719b71e07f7581af6.png";